import React, { useEffect, useRef, useState } from 'react';
import { I } from '@/lib/icons';
import GlobalSearchResults from '@/components/GlobalSearchResults';

export default function SidebarSearch() {
  const [q, setQ] = useState('');
  const [focused, setFocused] = useState(false);
  const wrapRef = useRef(null);

  // Close popover on outside click
  useEffect(() => {
    if (!focused) return undefined;
    const onDocDown = (e) => {
      if (!wrapRef.current?.contains(e.target)) setFocused(false);
    };
    document.addEventListener('mousedown', onDocDown);
    return () => document.removeEventListener('mousedown', onDocDown);
  }, [focused]);

  const showResults = focused && q.trim().length >= 2;

  return (
    <div ref={wrapRef} style={{ width: '100%', position: 'relative' }}>
      <form
        onSubmit={(e) => e.preventDefault()}
        role="search"
        style={{ width: '100%' }}
      >
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '8px 10px', borderRadius: 'var(--r-md)',
          background: 'var(--bg-surface)', border: '1px solid var(--border)',
        }}>
          <span style={{ color: 'var(--text-muted)', display: 'flex' }}>
            <I.search />
          </span>
          <input
            type="search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onFocus={() => setFocused(true)}
            placeholder="Hľadať FA, klienta, výdavok..."
            data-testid="sidebar-search-input"
            style={{
              flex: 1, minWidth: 0, border: 'none', outline: 'none', background: 'transparent',
              fontSize: 12.5, fontFamily: 'inherit', color: 'var(--text-primary)',
            }}
          />
          {q && (
            <button
              type="button"
              onClick={() => { setQ(''); }}
              aria-label="Vymazať hľadanie"
              style={{
                width: 18, height: 18, borderRadius: '50%',
                border: 'none', background: 'var(--bg-hover)',
                color: 'var(--text-muted)', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: 0, fontSize: 11, lineHeight: 1,
              }}
            >
              ×
            </button>
          )}
        </div>
      </form>

      {showResults && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            right: 0,
            zIndex: 100,
          }}
        >
          <GlobalSearchResults
            query={q}
            onPick={() => { setQ(''); setFocused(false); }}
            variant="popover"
          />
        </div>
      )}
    </div>
  );
}
